<template>
    <div class="space-y-2">
        <MeetingDetailsSectionTitle iconName="credit-card">
            Payment
        </MeetingDetailsSectionTitle>
        <div class="grid grid-cols-12 space-y-4 text-sm">
            <div class="col-span-12 md:col-span-4">
                <MeetingDetailsBlock
                    iconName="dollar-sign"
                    title="Total"
                >
                    {{ bookingPayment.amount.getValueAsDecimal() }}
                    {{ bookingPayment.amount.currency }}
                </MeetingDetailsBlock>
            </div>
            <div class="col-span-12 md:col-span-4">
                <MeetingDetailsBlock
                    iconName="external-link"
                    title="External Link"
                >
                    <a
                        :href="bookingPayment.externalViewUrl"
                        target="_blank"
                        class="text-blue-500 hover:underline"
                    >
                        {{ bookingPayment.externalViewText }}
                    </a>
                </MeetingDetailsBlock>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
    import { type PropType } from 'vue'
    import BookingPayment from '@/App/Booking/Payment/Entity/BookingPayment'
    import MeetingDetailsSectionTitle from '@/App/Booking/Meeting/Component/MeetingDetailsSectionTitle.vue'
    import MeetingDetailsBlock from '@/App/Booking/Meeting/Component/MeetingDetailsBlock.vue'

    const props = defineProps({
        bookingPayment: {
            type: Object as PropType<BookingPayment>,
            required: true,
        },
    })
</script>
